import React from 'react'
import './TomDashboardContainer.css'
import Switch from '@material-ui/core/Switch'
import {
  Button,
  Typography,
  IconButton,
  Tabs,
  Tab,
  Box,
} from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'
import { useTomDashboard } from '@auteco/hooks/useTomDashboard'
import DashboardTopInfo from '@auteco/components/TomDashboard/DashboardTopInfo'
import DashboardTable from '@auteco/components/TomDashboard/DashboardTable'
import AlertasModal from '@auteco/components/TomDashboard/AlertasModal'
import GestionTable from '@auteco/components/TomDashboard/GestionTable'

const TomDashboardContainer = () => {
  const {
    // Estados
    deltas,
    eventos,
    alertas,
    myRol,
    isLoadingDeltas,
    isLoadingAlertas,
    isLoadingEventos,
    isLoadingDocumento,
    isLoadingGestion,
    loadingRow,
    loadingRows,
    mostrarGestionados,
    openAlertDialog,
    mostrarAlertas,
    eventosGestion,
    activeTab,
    rowSelection,
    
    // Setters
    setMostrarGestionados,
    setOpenAlertDialog,
    setMostrarAlertas,
    setRowSelection,
    
    // Funciones
    refreshDashboardData,
    refreshGestionData,
    downloadExcel,
    handleEstadoChange,
    handleCheckClick,
    onAssignPedidos,
    onEditingRowSave,
    handleTabChange,
  } = useTomDashboard()

  // Renderizado del contenido del dashboard
  const renderDashboardContent = () => (
    <div style={{ padding: '20px', marginTop: '20px' }}>
      <DashboardTopInfo deltas={deltas} isLoadingDeltas={isLoadingDeltas} />
      
      <div className="switch-container">
        <Typography component="span">Gestionados</Typography>
        <Switch
          checked={mostrarGestionados}
          onChange={() => setMostrarGestionados(!mostrarGestionados)}
          color="primary"
        />
      </div>
      
      <Button
        disabled={isLoadingAlertas}
        className={`${isLoadingAlertas ? 'my-loading' : ''}`}
        onClick={() => setMostrarAlertas(true)}
        variant="contained"
        color="default"
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          background: '#ff00002e',
          zIndex: '20',
        }}
      >
        Alertas 🚨 ({alertas.length})
      </Button>
      
      <Button
        onClick={downloadExcel}
        variant="contained"
        color="primary"
        style={{ margin: '20px' }}
        disabled={isLoadingDocumento}
      >
        Descargar Excel
      </Button>

      <IconButton
        onClick={refreshDashboardData}
        style={{ margin: '20px', verticalAlign: 'middle' }}
        aria-label="Refrescar"
        disabled={isLoadingDeltas || isLoadingEventos || isLoadingAlertas}
      >
        <RefreshIcon />
      </IconButton>

      <div className={`${isLoadingEventos ? 'my-loading' : ''}`}>
        <DashboardTable 
          eventos={eventos} 
          mostrarGestionados={mostrarGestionados} 
        />
      </div>

      <AlertasModal
        openAlertDialog={openAlertDialog}
        setOpenAlertDialog={setOpenAlertDialog}
        mostrarAlertas={mostrarAlertas}
        setMostrarAlertas={setMostrarAlertas}
        alertas={alertas}
      />
    </div>
  )

  // Renderizado del contenido de gestión
  const renderGestionContent = () => (
    <div className="gestion-container">
      <div className={` ${isLoadingGestion ? 'my-loading' : ''}`}>
        <Button
          onClick={downloadExcel}
          variant="contained"
          color="primary"
          style={{ margin: '20px' }}
          disabled={isLoadingDocumento}
        >
          Descargar Excel
        </Button>

        <Button
          onClick={onAssignPedidos}
          variant="contained"
          color="primary"
          style={{ margin: '20px' }}
          disabled={isLoadingDocumento || isLoadingGestion || loadingRow || loadingRows.length > 0}
        >
          Gestionar pedidos seleccionados
        </Button>

        <IconButton
          onClick={refreshGestionData}
          style={{ margin: '20px', verticalAlign: 'middle' }}
          aria-label="Refrescar"
          disabled={isLoadingGestion}
        >
          <RefreshIcon />
        </IconButton>

        <GestionTable
          eventosGestion={eventosGestion}
          myRol={myRol}
          handleEstadoChange={handleEstadoChange}
          handleCheckClick={handleCheckClick}
          loadingRow={loadingRow}
          loadingRows={loadingRows}
          rowSelection={rowSelection}
          setRowSelection={setRowSelection}
          onEditingRowSave={onEditingRowSave}
        />
      </div>
    </div>
  )

  return (
    <div style={{ padding: '20px', marginTop: '20px' }}>
      <Tabs value={activeTab} onChange={handleTabChange} indicatorColor="primary" textColor="primary">
        <Tab label="Dashboard" />
        <Tab label="Gestión" />
      </Tabs>
      
      <Box role="tabpanel" hidden={activeTab !== 0}>
        {activeTab === 0 && renderDashboardContent()}
      </Box>
      
      <Box role="tabpanel" hidden={activeTab !== 1}>
        {activeTab === 1 && renderGestionContent()}
      </Box>
    </div>
  )
}

export default TomDashboardContainer
